import { z } from "zod";

export const bookmarkItemSchema = z.object({
    id: z.string(),
    title: z.string(),
    url: z.string(),
    type: z.enum(["customer", "farm", "device", "technician"]),
});
